export default "__VITE_ASSET__B5KXdDeI__"